<template>
  <div v-if="isShowLoadingAnimation">
    <loading-screen></loading-screen>
  </div>
  <div v-else class="thanks-page-content text-center mx-auto">
    <div class="thanks-page-info">
      <div class="thank-you-text">
        <p class="font-weight-bold fs-24 mb-0">
          Thank you {{ vehicleInfo.customerName }} for your enquiry on AutoFlip.
        </p>
      </div>
      <div class="complete-your-listing pt-4">
        <p class="section-header font-weight-bold fs-24">COMPLETE YOUR LISTING</p>
        <p class="font-weight-thin mb-4">To get your car listed faster, finish adding more details.</p>
        <button type="button" @click="handleAddDetails">
          <span class="font-weight-regular">ADD MORE DETAILS</span>
        </button>
      </div>
    </div>
    <div class="thanks-page-question mb-4">
      <p class="section-header font-weight-bold fs-24">WHAT TO EXPECT NEXT?</p>
      <ul class="desc">
        <li
          v-for="(item, index) in whatToExpectNextContent"
          :key="index"
          class="font-weight-thin"
        >
          {{ item }}
        </li>
      </ul>
    </div>
    <how-we-work></how-we-work>
  </div>
</template>

<script>
import HowWeWork from "@/components/thanks-page/HowWeWork";
import { mapState } from "vuex"
import LoadingScreen from "@/components/thanks-page/LoadingScreen";
import customerDetailService from "@/services/customer-detail";
import { API_ENDPOINT } from "@/config";
import { EventBus } from '@/helper/event-bus';

export default {
  name: "Index",
  data() {
    return {
      vehicleInfo: { ...this.$store.getters.curVehicleInfo },
      isMobile: true,
      valuation: {},
      isShowLoadingAnimation: false,
      apiEndPoint: API_ENDPOINT,
    };
  },
  computed: {
    ...mapState({
      contactDetails: (state) => state.commonVariables.contactDetails,
    }),
    mobileMediaQuery: function() {
      return window.matchMedia("(min-width: 1000px)");
    },
    isNotSelling: function() {
      return this.vehicleInfo.sell === "I'm not selling";
    },
    fromPrice() {
      return "$" + new Intl.NumberFormat().format(this.vehicleInfo.from);
    },
    toPrice() {
      return "$" + new Intl.NumberFormat().format(this.vehicleInfo.to);
    },
    discretePrice() {
      return "$" + new Intl.NumberFormat().format(this.vehicleInfo.discreteValue);
    },
    hasGotPrice: function() {
      return this.vehicleInfo.from > 0 && this.vehicleInfo.to > 0;
    },
    whatToExpectNextContent: function() {
      return !this.isNotSelling
        ? [
            "Before your car is officially listed for sale, a member of our customer service team will contact you within the next business day.",
            "They'll confirm a few details, advise you on valuing your car, answer any questions and then go to work to get you the best price, fast.",
            "In the meantime, you can continue updating your details by clicking the link provided in the confirmation email you'll receive shortly.",
          ]
        : [
            "A friendly team member from AutoFlip may call you to check if they can assist with anything for your car.",
            "If you change your mind and decide to sell your car, continue updating your details by clicking the link provided in the confirmation email you'll receive shortly.",
          ];
    },
  },
  methods: {
    // goBack() {
    //   this.$router.push({name: 'vehicle-info'})
    // }
    async handleAddDetails() {
      try {
        const response = await customerDetailService.getAppraisalId(this.$store.getters.carDetailRecordId, { disableToast: true });
        const appraisalId = response?.data?.appraisalId;
        if (response.data.uploadStatus === 'autoplay_upload_success' && appraisalId) {
          await customerDetailService.updatePSPDataLogsWithAction({
            appraisalId,
            loggedAction: 'MyCar Direct CTA',
          });
          this.redirectToMyCarPage(appraisalId);
        } else {
          localStorage.setItem('customerEmail', this.vehicleInfo.customerEmail);
          this.isShowLoadingAnimation = true;
          EventBus.$emit('show-loading-screen');
        }
      } catch (error) {
        console.error("Failed to fetch appraisal ID:", error);
        this.isShowLoadingAnimation = true;
        EventBus.$emit('show-loading-screen');
      }
    },
    getMyCarPage() {
      let redirectBase = '';
      if (this.apiEndPoint.includes('psp-test')) {
        redirectBase = 'https://psp-test.idomitech.net/inv10';
      } else if (this.apiEndPoint.includes('psp-staging')) {
        redirectBase = 'https://psp-staging.idomitech.net/inv10';
      } else if (this.apiEndPoint.includes('autoflip.com.au')) {
        redirectBase = 'https://mycar.autoflip.com.au';
      }
      return redirectBase;
    },
    redirectToMyCarPage(appraisalId) {
      const generatedTime = new Date();
      const redirectUrl = `${this.getMyCarPage()}?universal_login=true&appraisalId=${appraisalId}&locid=2&generated_time=${
        generatedTime.getTime()}&utm_source=direct_mycar`;
      window.location.href = redirectUrl;
    },
  },
  components: {
    HowWeWork,
    LoadingScreen,
  },
  mounted() {
    // Check mobile screen
    this.mobileMediaQuery.addListener((e) => {
      if (e.matches) {
        this.isMobile = false;
      } else {
        this.isMobile = true;
      }
    });

    this.isMobile = !this.mobileMediaQuery.matches;
  },
};
</script>

<style lang="scss">
.thanks-page-content {
  color: #404040;

  .thanks-page-info {
    background-color: #f9fafb;
    padding: 20px;
  }

  .thanks-page-question {
    .section-header {
      color: #1f8252;
      text-transform: uppercase;
      margin: 1rem 0;
    }
    .desc {
      padding-inline-start: 35px;
      padding-right: 20px;
      li {
        text-align: left;
      }
    }
  }

  .complete-your-listing {
    .section-header {
      color: #1f8252;
      text-transform: uppercase;
      margin: 1rem 0;
    }

    button {
      width: 100%;
      max-width: 722px;
      height: 46px;
      border-radius: 6px;
      padding: 11px 24px;
      background-color: #1F8252;
      border: none;
      outline: none;
      color: white;
      font-size: 16px;
    }
  }

  .lean-info {
    padding-bottom: 30px;
    margin-bottom: 20px;
  }
}

@media screen and (min-width: 768px) {
  .thanks-page-content {
    .thank-you-text p {
      margin: 0 auto;
      max-width: 800px;
    }
    .main-content {
      padding-bottom: 30px !important;
      .vehicle {
        max-width: 980px;
        display: flex;
        justify-content: space-between;
      }
      .text-note {
        max-width: 515px !important;
        margin-top: 17px !important;
        padding: 0 !important;
      }
      .item {
        padding: 0px 22px !important;
      }
    }
    .lean-info {
      margin: 0;
      width: 100%;
      max-width: unset;
      .title-info {
        padding-top: 20px;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .content-detail-tittle{
    font-size: 20px !important;
  }

  .main-content-title {
    font-size: 20px !important;
  }

  .car-note {
    text-align: left !important;
  }
  
  .autoflip-price {
    max-width: 303px !important;

    .no-valuation {
      font-size: 20px !important;
    }
  }
  
  .no-price {
    max-width:303px !important;
  }
}

@media screen and (min-width: 768px) and (max-width: 1000px) {
  .title-content {
    .top-head {
      margin-bottom: 0rem !important;
      font-size: 22px !important;
      padding-top: 12px !important;
    }
    .desc {
      margin-top: 2px !important;
      .bottom-head {
        font-size: 22px !important;
        margin-bottom: 10px !important;
      }
      .desc-content {
        font-size: 14px !important;
      }
    }
  }
}

@media screen and (max-width: 450px) and (orientation: portrait){
  .top-head {
    padding: 0 16px;
  }
}
@media screen and (min-width: 768px) and (max-width: 991px) {
  .main-content {
    .vehicle-non-slide {
      max-width: 600px !important;
    }
    .vehicle-slide {
      max-width: 625px !important;
    }
    .vehicle {
      display: block !important;
      justify-content: unset !important;
      .vehicle-condition {
        margin: 0 auto !important;
        width: 100% !important;
        max-width: 515px !important;
        .vehicle-condition-wrapper {
          flex-direction: column !important;
          .vehicle-condition-item {
            margin: 0 auto !important;
            transform: scale(1.1);
          }
        }
      }
      .vehicle-detail {
        margin: 0 auto !important;
        width: 100% !important;
        max-width: 515px !important;
        margin-top: 50px !important;
      }
    }
  }
}
@media screen and (min-width: 992px) and (max-width: 1199px) {
  .vehicle {
    .vehicle-condition {
      margin-left: 5px !important;
    }
    .vehicle-detail {
      margin-right: 5px !important;
    }
  }
}
@media screen and(min-width: 900px) {
  .thanks-page-content {
    .thanks-page-question {
      .desc {
        max-width: 620px;
        margin: 0 auto;
      }
    }
  }
}
@media screen and(min-width: 990px) {
  .thanks-page-content {
    .main-content {
      .text-note {
        margin-left: 0 !important;
      }
    }
  }
}
@media screen and(min-width: 1200px) {
  .thanks-page-content {
    padding: 0 10px;
    .thank-you-text p {
      font-size: 27px !important;
    }
    .thanks-page-question {
      .desc {
        max-width: 800px;
      }
    }
    .lean-info .type-info {
      max-width: 1050px !important;
      margin: 0 auto;
    }
  }
}
</style>
